import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { FaPlus, FaHeart } from 'react-icons/fa';
import { getAvailableGetAllFavouriteProduct } from '../redux/pos/posSlice';
import { addToCart } from '../redux/addCart/cartSlice';
import { getImagePath } from '../constants/defaultValues';
import { useThemeColors } from '../hooks/useThemeColors';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import FavoriteButton from './common/FavouriteButton';

const MyFavourite = ({ darkMode, orderType }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Hook se central colors le rahe hain
  const {
    themeBg,
    cardBg,
    textColor,
    subTextColor,
    borderColor,
    isDark,
    contentBg,
  } = useThemeColors(darkMode);

  const allFavouriteProduct = useSelector(getAvailableGetAllFavouriteProduct);

  // Reversing to show latest first
  const reversedFavourites = allFavouriteProduct
    ? [...allFavouriteProduct].reverse()
    : [];

  const handleAddToCartClick = (e, fav) => {
    e.stopPropagation();
    const itemToAdd = {
      id: fav.favouriteProduct?.productId,
      name: fav.productName || 'Product',
      shopPrice: fav.productPrice || 0,
      image: fav.defaultImage,
      orderType,
    };
    dispatch(addToCart(itemToAdd));
    toast.success(`✅ ${fav.productName} added to cart!`);
  };

  return (
    <div
      className="my-favourite-page"
      style={{
        backgroundColor: themeBg, // Main background consistent with App
        minHeight: '100vh',
        transition: '0.3s ease',
      }}
    >
      <div className="container pb-5 pt-4">
        {/* Header Section */}
        <div className="row mb-5 align-items-center">
          <div className="col-md-8">
            <div className="d-flex align-items-center mb-1">
              <FaHeart className="text-danger me-2" size={24} />
              <h2
                className="fw-bold mb-0"
                style={{ color: textColor, letterSpacing: '-1px' }}
              >
                My Favourites
              </h2>
            </div>
            <p style={{ color: subTextColor, fontSize: '0.95rem' }}>
              Your most-loved pizza and deals in one place
            </p>
          </div>
          <div className="col-md-4 text-md-end">
            <div
              className="badge px-4 py-2 rounded-pill fw-bold"
              style={{
                backgroundColor: isDark
                  ? 'rgba(220, 53, 69, 0.2)'
                  : 'rgba(220, 53, 69, 0.1)',
                color: '#dc3545',
              }}
            >
              {reversedFavourites.length} Items Saved
            </div>
          </div>
        </div>

        {/* Products Grid */}
        <div className="row g-4">
          {reversedFavourites.length > 0 ? (
            reversedFavourites.map((fav, index) => {
              const name = fav.productName;
              const price = fav.productPrice;
              const fileToken = fav.defaultImage?.fileToken;
              const pId = fav.favouriteProduct?.productId;

              return (
                <div key={index} className="col-12 col-md-6 col-lg-3">
                  <div
                    className="card h-100 border-0 shadow-sm position-relative overflow-hidden fav-card"
                    style={{
                      backgroundColor: cardBg, // Card surface color
                      borderRadius: '20px',
                      border: `1px solid ${borderColor}`,
                      transition:
                        'transform 0.3s ease, background-color 0.3s ease',
                    }}
                  >
                    {/* Reuse your floating FavoriteButton */}
                    <div
                      style={{
                        position: 'absolute',
                        // top: '12px',
                        // left: '12px',
                        zIndex: 10,
                      }}
                    >
                      <FavoriteButton productId={pId} darkMode={isDark} />
                    </div>

                    {/* Image Section - Edge to Edge */}
                    <div
                      className="text-center overflow-hidden"
                      style={{
                        backgroundColor: isDark
                          ? 'rgba(255,255,255,0.03)'
                          : 'rgba(0,0,0,0.02)',
                        height: '180px',
                        borderBottom: `1px solid ${borderColor}`,
                      }}
                    >
                      {fileToken ? (
                        <img
                          src={`${getImagePath}${fileToken}`}
                          className="w-100 h-100 object-fit-cover card-img-effect"
                          alt={name}
                          style={{ transition: '0.5s' }}
                        />
                      ) : (
                        <div
                          className="w-100 h-100 d-flex align-items-center justify-content-center"
                          style={{ color: subTextColor }}
                        >
                          No Image
                        </div>
                      )}
                    </div>

                    <div className="card-body d-flex flex-column p-3">
                      <h6
                        className="fw-bold mb-2 text-truncate"
                        style={{ color: textColor, fontSize: '1rem' }}
                      >
                        {name || 'Unknown Item'}
                      </h6>

                      <div className="d-flex justify-content-between align-items-center mt-auto">
                        <div className="fw-bold text-danger fs-5">
                          <span
                            style={{ fontSize: '0.8rem', marginRight: '2px' }}
                          >
                            Rs
                          </span>
                          {price !== null && price !== undefined
                            ? Number(price).toLocaleString()
                            : '---'}
                        </div>
                        <button
                          className="btn btn-danger rounded-circle p-0 d-flex align-items-center justify-content-center shadow-sm"
                          style={{
                            width: '38px',
                            height: '38px',
                            border: 'none',
                          }}
                          onClick={(e) => handleAddToCartClick(e, fav)}
                        >
                          <FaPlus size={14} />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            /* Empty State */
            <div className="col-12 text-center py-5">
              <div
                className="py-5 px-4 rounded-5"
                style={{
                  backgroundColor: cardBg,
                  border: `2px dashed ${borderColor}`,
                }}
              >
                <div
                  className="mb-4 d-inline-flex align-items-center justify-content-center rounded-circle"
                  style={{
                    width: '100px',
                    height: '100px',
                    backgroundColor: isDark
                      ? 'rgba(255,255,255,0.05)'
                      : 'rgba(0,0,0,0.03)',
                  }}
                >
                  <FaHeart size={50} className="text-muted opacity-25" />
                </div>
                <h4 className="fw-bold mb-2" style={{ color: textColor }}>
                  Your list is empty
                </h4>
                <p
                  className="mb-4 mx-auto"
                  style={{ color: subTextColor, maxWidth: '300px' }}
                >
                  Looks like you haven't saved any pizzas to your favourites
                  yet.
                </p>
                <button
                  className="btn btn-danger px-5 py-3 rounded-pill fw-bold shadow-sm text-uppercase"
                  style={{ fontSize: '0.85rem', letterSpacing: '1px' }}
                  onClick={() => navigate('/')}
                >
                  Explore Menu
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      <style
        dangerouslySetInnerHTML={{
          __html: `
        .fav-card {
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        .fav-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 12px 20px rgba(0,0,0,0.15) !important;
        }
      `,
        }}
      />
    </div>
  );
};

export default MyFavourite;